import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
  en: {
    timeshift: {
      casual: 'Casual',
      common: {
        employeeId: 'Employee Id',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phoneNumber: 'Phone Number',
        role: 'Role',
        hiredDate: 'Hire Date',
        leavingDate: 'Leaving Date',
        notAvailable: 'Not available',
        yes: 'Yes',
        no: 'No',
        save: 'Save',
        confirm: 'Confirm',
        cancel: 'Cancel',
        available: 'Available',
        days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
          bankHolidays: 'Bank Holidays'
        }
      },
      team: {
        headers: {
          employee: 'Employee',
          role: 'Role',
          employeeId: 'Employee Id'
        },
        search: {
          placeholder: 'Search by name, role, or employee ID',
          search: 'Search'
        },
        filters: {
          skills: 'Skills',
          availableDays: 'Available Days',
          days: 'Days',
          locations: 'Locations',
          activeFilters: 'Active filters',
          clearAll: 'Clear All Filters'
        },
        pagination: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          prev: 'Prev'
        },
        noResults: 'No results found'
      },
      teamMember: {
        calendar: {
          viewDetails: 'View details',
          viewPendingRequest: 'View pending request',
          cancel: 'Cancel',
          bookLeave: 'Book Leave',
          setAvailability: 'Set Availability'
        },
        personalInfo: {
          cardTitle: 'Personal Information',
          homeLocation: 'Primary Location',
          locations: 'Locations'
        },
        requests: {
          table: {
            dateSubmitted: 'Date Submitted',
            requestDetails: 'Request Details',
            status: 'Status',
            action: 'Action',
            viewDetails: 'View Details'
          },
          filters: {
            filter: 'Filter',
            status: 'Status',
            requestType: 'Request Type'
          },
          scheduleUpdate: {
            cardTitle: 'Update Schedule Request',
            requestStatus: 'Request Status',
            requestSubmitted: (date: string) => `Submitted: ${date}`,
            effectiveFrom: `New Schedule Start Date`,
            hoursBefore: (day: string) => `${day} Hours Before`,
            hoursAfter: (day: string) => `${day} Hours After`,
            rejectionReason: 'Reason for Rejection'
          },
          leaveRequest: {
            pageTitle: 'Leave Request',
            approveTitle: 'Approve leave request',
            approveMessage: 'Are you sure you want to approve this leave request?',
            approveSuccess: 'Leave request approved.',
            rejectTitle: 'Deny leave request',
            rejectMessage: 'Are you sure you want to deny this leave request?',
            rejectSuccess: 'Leave request denied.'
          },
          availabilityRequest: {
            pageTitle: 'Availability Change',
            approveTitle: 'Approve availability change',
            approveMessage: 'Are you sure you want to approve this availability change?',
            approveSuccess: 'Availability change approved.',
            rejectTitle: 'Deny availability change',
            rejectMessage: 'Are you sure you want to deny this availability change?',
            rejectSuccess: 'Availability change denied.'
          }
        },
        skills: {
          cardTitle: 'Skills',
          assignedSkills: 'Assigned Skills',
          noAssignedSkills: 'No skills assigned'
        },
        preferedSchedule: {
          cardTitle: 'Prefered Schedule',
          editPreferedSchedule: 'Edit Prefered Schedule',
          availableFrom: 'Available From',
          availableTo: 'Available To'
        },
        permissions: {
          cardTitle: 'Permissions',
          role: 'Role',
          assignedPersonas: 'Assigned Personas',
          edit: 'Edit Permissions',
          noRolesAvailable: 'No roles available',
          invalidSelectedRole: 'Selected role is invalid'
        },
        workRules: {
          cardTitle: 'Work Rules',
          minimumMonthlyHours: 'Minimum Monthly Hours',
          maximumMonthlyHours: 'Maximum Monthly Hours',
          minimumWeeklyHours: 'Minimum Weekly Hours',
          maximumWeeklyHours: 'Maximum Weekly Hours',
          probationEndDate: 'Probation End Date',
          edit: 'Edit Work Rules'
        },
        contractDetails: {
          cardTitle: 'Contract Details',
          edit: 'Edit Contract',
          contractName: 'Contract Name',
          employeeContract: 'Employee Contract',
          roleName: 'Role Name',
          earliestStartTime: 'Earliest Start Time',
          latestEndTime: 'Latest End Time',
          maxShiftHours: 'Maximum Hours Per Shift',
          minHoursPerWeek: 'Minimum Hours Per Week',
          maxHoursPerWeek: 'Maximum Hours Per Week',
          minHoursPerDay: 'Minimum Hours Per Day',
          maxHoursPerDay: 'Maximum Hours Per Day',
          maxDaysPerWeek: 'Maximum Days Per Week',
          maxConsecutiveDays: 'Maximum Consecutive Days',
          maxHoursPerShift: 'Maximum Hours Per Shift',
          allowOvertime: 'Allow Overtime',
          confirmationTitle: 'Change Contract?',
          confirmationMessage:
            'This will only impact rosters going forward, any previous shifts may not obey these rules.'
        },
        leaveBalances: {
          cardTitle: 'Leave Allocation',
          edit: 'Edit leave allocation',
          description:
            'These determine the maximum number of days an employee can claim for this leave type. A value of 0 means no limit is enforced.',
          limitsFor: 'Limits for',
          noLimits: 'No leave limits are configured.',
          yearly: 'Yearly',
          monthly: 'Monthly',
          selectYear: 'Select Year',
          selectMonth: 'Select Month',
          recurring: 'Recurring',
          invalidAmount: 'Enter a number of 0 or more.',
          saveSuccess: 'Leave allocation successfully updated.',
          saveError: "Unable to update team member's leave allocation.",
          carriedOver: (days: number) => `${days} carried over`,
          overAllowance: (label: string, days: number) =>
            `This booking would put the employee ${days} ${days === 1 ? 'day' : 'days'} over their leave allowance for ${label}.`,
          remainingAfter: (n: number, label: string) =>
            `The employee will have ${n} ${n === 1 ? 'day' : 'days'} remaining ${label} after this booking.`,
          warningTitle: 'Leave balance warning',
          confirmLabel: 'Book anyway',
          warningContinue: 'Continue with this booking?',
          warningMessage: "This booking would exceed the employee's configured leave allowance. You can still proceed.",
          requestLeave: 'Request Leave',
          overlapBlocked:
            'This employee already has leave or an availability exception on these days, either approved or pending. Cancel or decide on these before booking leave:'
        },
        actions: {
          cardTitle: 'Actions',
          passwordReset: {
            label: 'Password Reset',
            description: 'Send the user an email to reset their password',
            sendEmail: 'Send Email',
            success: 'Password reset email sent, it may take a few minutes to arrive',
            error: 'Failed to send password reset email, please try again'
          }
        },
        timeWorked: {
          cardTitle: (dateString: string) => `Time Worked For ${dateString}`,
          totalShiftsScheduled: 'Total Shifts Scheduled',
          totalFreeDays: 'Total Free Days',
          hoursWorked: 'Hours Worked',
          minimumHours: 'Minimum Hours',
          maximumHours: 'Maximum Hours'
        },
        annualLeave: {
          cardTitle: `Leave Balances`,
          edit: 'Adjust Balances',
          leaveType: 'Leave Type',
          daysCarriedOver: 'Days Carried Over',
          totalAllowance: 'Total Allowance',
          daysTaken: 'Days Taken',
          pending: 'Pending',
          daysRemaining: 'Days Remaining',
          editForm: {
            cardTitle: 'Leave Allocation',
            edit: 'Edit leave allocation',
            description:
              'These determine the maximum number of days an employee can claim for this leave type. A value of 0 means no limit is enforced.',
            limitsFor: 'Limits for',
            noLimits: 'No leave limits are configured.',
            yearly: 'Yearly',
            monthly: 'Monthly',
            selectYear: 'Select Year',
            selectMonth: 'Select Month',
            recurring: 'Recurring',
            invalidAmount: 'Enter a number of 0 or more.',
            daysCarriedOver: (days: number) => `Days carried over: ${days}`,
            daysTaken: (days: number) => `Days taken this leave year: ${days}`,
            saveSuccess: 'Leave allocation successfully updated.',
            saveError: "Unable to update team member's leave allocation.",
            carriedOver: (days: number) => `${days} carried over`
          }
        },
        scheduleDay: {
          leaveType: 'Availability / Leave Type',
          availabilityStart: 'Availability Start',
          availabilityEnd: 'Availability End'
        },
        scheduleNotFound: `Employee schedule cannot be found, this may be because the employee does not have a schedule set up yet. Or you do not have permission to view this employee's schedule.`,
        backToMonthView: 'Back To Month View',
        employeeStatus: 'Employee Status',
        availableFrom: 'Available From',
        availableUntil: 'Available Until',
        usualPattern: (day: string) => `Usual Working ${day} Pattern`,
        menu: {
          personal: 'Personal',
          annualLeave: 'Annual Leave',
          requests: 'Requests',
          stats: 'Stats',
          calendar: 'Calendar',
          skills: 'Skills',
          workRules: 'Work Rules',
          actions: 'Actions'
        },
        calendarDayView: {
          availability: 'Availability',
          editAvailability: {
            title: 'Adjust Availability',
            availabilityLeaveType: 'Availability / Leave Type',
            availabilityStart: 'Availability Start',
            availabilityEnd: 'Availability End'
          },
          employeeStatus: 'Employee Status',
          availableFrom: 'Available From',
          availableUntil: 'Available Until',
          usualWorkingPattern: (dayName: string) => `Usual ${dayName} Working Pattern`,
          roster: 'Roster',
          breakLabel: 'Break Time',
          shiftStart: 'Shift Start',
          shiftEnd: 'Shift End',
          noShiftDetails: 'No shift details available',
          shiftLocation: 'Shift Location',
          viewDetails: 'View Roster'
        }
      }
    },
    ess: {
      myProfile: {
        title: 'My Profile',
        email: 'Email',
        phone: 'Phone',
        notification: 'Notification',
        sms: 'SMS',
        editInfo: 'Edit Info'
      },
      home: {
        casual: 'Casual'
      },
      announcements: {
        title: 'Announcements'
      },
      monthlyShift: {
        title: 'Monthly Shift',
        monthlySchedule: 'Monthly Schedule',
        noShifts: 'Monthly schedule is not ready yet',
        published: (date: string, time: string) => `Published ${date} (${time})`
      },
      vacantShifts: {
        title: 'Vacant Shifts'
      },
      availability: {
        title: 'Availability',
        totalEmployees: 'Total employees submitting holiday requests.',
        saveConfirm: 'You have unsaved changes to your availability. Are you sure you want to leave?',
        submitAvailability: 'Submit',
        mode: {
          name: {
            work: 'Work',
            available: 'Available',
            roster: 'RDO',
            paid: 'Paid',
            unavailable: 'Unavailable'
          },
          label: {
            roster: 'RDO',
            paid: 'Paid day off'
          },
          description: {
            cannotEdit: 'cannot edit',
            default: 'Default',
            taps: (count: number) => (count > 0 ? `${count} tap${count === 1 ? '' : 's'}` : '')
          }
        },
        warningModal: {
          titleWarnings: 'Warnings',
          titleErrors: 'Errors',
          exceededMandatory: (numberRequired: number, numberTaken: number, type: string) =>
            `You may not take more than ${numberRequired} ${type} days in this roster period. (Days taken: ${numberTaken})`,
          exceededWarning: (numberRequired: number, numberTaken: number, type: string) =>
            `You are above the recommended limit of ${numberRequired} ${type} days in this roster period. (Days taken: ${numberTaken})`,
          notMetMandatory: (numberRequired: number, numberTaken: number, type: string) =>
            `You are required to take ${numberRequired} ${type} days in this roster period. (Days taken: ${numberTaken})`,
          notMetWarning: (numberRequired: number, numberTaken: number, type: string) =>
            `You are below the recommended limit of ${numberRequired} ${type} days in this roster period. (Days taken: ${numberTaken})`,
          availabilityBelowMinDuration: (date: string, duration: number, minShiftDuration: number) => `
          Availability for ${date} is below the min shift duration: ${minShiftDuration} hours. (Duration: ${duration} hours)
          `,
          availabilityOutsidePattern: (date: string, patternStart: string, patternEnd: string) => `
          Availability for ${date} is outside of your usual working pattern. (Usual pattern: ${patternStart} - ${patternEnd})
          `
        }
      }
    },
    daily: {
      drag: {
        instructions: 'Drag & drop to change the chart:',
        shiftTypes: {
          work: 'Work',
          break: 'Break',
          business: 'Business'
        },
        shift: 'Shift',
        tasks: 'Tasks',
        showAll: 'Show all',
        showFavourites: 'Show favourites',
        expand: 'Expand',
        taskTooltips: {
          capableStaffCount: (count: number, date: string) => `${count} staff can do this task on: ${date}`,
          capableStaffCountTemplate: (count: number) =>
            `There are ${count} staff skilled to perform this task as this location`,
          mandatorySkills: 'Mandatory skills',
          optionalSkills: 'Optional skills',
          noMandatorySkills: 'No mandatory skills',
          noOptionalSkills: 'No optional skills',
          staffWhoCanPerform: 'Staff who can perform this task',
          noStaffCanPerformTask: 'No staff have all the mandatory skills to perform this task',
          availableToday: (time: string) => `Available today ${time}`,
          notAvailableToday: 'Not available today'
        }
      },
      roster: {
        noRoster: 'No roster has been created for this day. Would you like to create one from the template?',
        create: 'Create Roster',
        createInProgress: 'Creating a roster...',
        unsaved: 'Your roster has unsaved changes. Are you sure you want to leave?',
        leaveWithoutSaving: 'Leave without saving',
        saveAndLeave: 'Save and leave',
        noStaff: 'No staff available',
        budgetStats: {
          totalHq: 'Monthly Location Forecast',
          totalRostered: 'Monthly Rostered Budget',
          monthlyDelta: 'Monthly Delta Time',
          locationForecast: 'Location Forecast',
          rosteredBudget: 'Rostered Budget',
          deltaTime: 'Delta Time',
          totalHqAllocatedBudget: 'Total HQ Allocated Budget',
          monthlyLocationForecast: 'Monthly Location Forecast',
          monthlySales: 'Monthly sales',
          dailySales: 'Daily sales'
        },
        selectTemplate: 'Select template',
        changeTemplateWarning:
          'Changing the template will replace all roster data for this day. Would you like to change the template?',
        deleteReassignedShiftWarning:
          'Please arrange for the assigned staff member to be removed from the providing location.',
        templates: {
          label: 'Templates',
          saveAsNew: 'Save as new template',
          saveAsNewTitle: 'Do you want to save this pattern as new template?',
          replaceExisting: 'Replace existing template',
          replaceExistingTitle: 'Do you want to replace existing template?',
          replace: 'Replace',
          replaceTemplate: 'Replace Template',
          chooseTemplate: 'Choose your template destination',
          replaceWarning: (name: string) =>
            `Template with name "${name}" already exists. Would you like to replace the existing template?`,
          maxTemplatesLimitReached: (limit: number) =>
            `The limit of "${limit}" allowed custom templates has been already reached! You can replace your current templates instead.`,
          tooltip: {
            templateName: (name: string) => `Template imported as ${name}`,
            templateVersion: (version: string) => `Version ${version}`
          }
        },
        publish: 'Publish Roster',
        published: 'Published',
        publishedSuccessMessage: 'Roster Published Successfully!',
        publishedFailureMessage: 'Roster could not be published.',
        editRoster: 'Edit Roster',
        unpublishConfirmTitle: 'Edit this roster?',
        unpublishConfirmBody:
          'This will unpublish the roster so you can make changes. Staff members will not be able to see the roster until you publish it again.',
        unpublishConfirmButton: 'Unpublish & Edit',
        unpublishedSuccessMessage: 'Roster Unpublished Successfully!',
        unpublishedFailureMessage: 'Roster could not be unpublished.',
        lastSaved: 'Last Saved',
        lastPublished: 'Last Published',
        notifyVacant: 'Announce Vacant Shifts',
        deleteModal: {
          title: 'Delete roster',
          message: 'Are you sure you want to delete this roster?'
        },
        saveWorkInProgressModal: {
          title: 'Save work in progress',
          message: 'You are saving a shift does not have any time allocated, do you want to continue?'
        },
        tooltip: {
          noneAssigned: 'No staff member has been assigned to this shift.',
          probationary: (date: string) => `On probation until ${date}`,
          foreignStudent: 'Foreign student',
          notAdult: 'Under 18 years of age',
          ageNotSpecified: 'Employees age is not recorded',
          leaving: (date: string) => `Leaving on ${date}`,
          left: (date: string) => `Left on ${date}`,
          management: '(Management Level)',
          templateName: (name: string) => `Roster created from ${name}`,
          templateVersion: (version: string) => `Version ${version}`,
          unableToGetTemplate: 'Template data is not available',
          lastUpdated: 'Last edit:',
          templateAssignedEmployee: 'Employee assigned in template',
          templateAssignedRole: 'Role assigned in template',
          role: 'Role:',
          contractType: 'Contract Type:',
          break: 'Break'
        },
        noRosterCreated: 'No roster was created for this day.',
        print: {
          title: (date: string, location: string) => `${location}: Daily roster for ${date}`,
          fileName: (date: string, location: string) => `roster-${location}-${date}.pdf`
        },
        errors: {
          employeeAlreadyAssigned: (employeeName: string, employeeId?: string) =>
            `${employeeName} (${employeeId ?? ''}) is already assigned to another location`
        },
        noNotes: 'No notes for this roster day.',
        rosterHistory: 'Roster History',
        shiftLockedError: `This shift is locked. Please unlock it before changing to a different employee.`
      },
      templates: {
        noTemplates: 'No templates have been defined for this location.',
        creatingTemplate: 'Setting up the template...',
        selectRole: 'Select role',
        unsaved: 'Your template has unsaved changes. Are you sure you want to leave?',
        createReplaceUnsaved:
          'Not all your changes have been saved. Are you sure you want to copy the previously saved state?',
        clearTemplate: 'Clear Template',
        listTitle: 'Templates',
        noTemplateSelected: 'No template selected.',
        editorFallbackTitle: 'Template',
        saveSuccessMessage: 'Template saved successfully!',
        renameModal: {
          title: 'Rename Template',
          label: 'Template Name',
          generalError: 'Unable to rename template'
        },
        contractTypes: {
          shopManager: 'Shop Manager',
          deputyShopManager: 'Deputy Shop Manager',
          fullTime: 'Full Time',
          partTime: 'Partner',
          reducedHours: 'Reduced Hours',
          zeroHours: 'Sales Staff',
          casual: 'Casual',
          student: 'Student'
        },
        myTemplates: {
          label: 'My Templates',
          createNewTemplate: 'New template',
          noTemplates: 'No templates created yet.',
          nameRequired: 'Template name is required.',
          nameExists: 'Template name already exists.',
          addModal: {
            title: 'Create a new template',
            enterTemplateName: 'Enter template name',
            generalError: 'Unable to create template'
          },
          editModal: {
            title: 'Edit custom template',
            editTemplateName: 'Edit template name',
            generalError: 'Unable to edit template'
          },
          deleteModal: {
            title: 'Delete custom template',
            deleteConfirmation: (name: string) =>
              `Click the Delete button to remove the '${name}' template from the templates list.`,
            generalError: 'Unable to delete template',
            inUseError: 'Template is in use- unable to delete'
          },
          limitModal: {
            title: 'Template Limit Reached',
            info: (max: number) =>
              `You have reached the limit of ${max} custom template${
                max === 1 ? '' : 's'
              }. Please delete an existing template before adding a new one.`
          }
        },
        shopTemplates: 'Shop Templates',
        libraryTemplates: 'Library Templates',
        library: {
          notPermitted: 'Only a template librarian may view this page.',
          noneCreated: "You haven't created any library templates yet.",
          create: 'Create New Library Template',
          importModal: {
            title: 'Import Library Template',
            selectTemplate: 'Please select a template to import.',
            pleaseSelect: 'Please select',
            alreadyImported: 'That template has already been imported.',
            mustSelect: 'You must select a template.',
            noTemplates: 'No library templates have been defined',
            noSearchResults: 'There are no templates matching your search.',
            placeholder: 'Search for a template by name or by tag'
          }
        },
        noNotes: 'No notes for this template.',
        templateHistory: 'Template History',
        importNotes: (dateString: string, libraryName: string) =>
          `Template imported as ${libraryName} on ${dateString}.` as string,
        version: 'Version',
        tags: {
          label: 'Tags',
          description: 'You can add tags to your template to make them easier to search.',
          placeholder: 'Enter a name for your tag',
          otherTags: 'Other Tags:',
          andMore: (count: number) => `+${count} more`,
          none: 'No tags defined'
        }
      },
      summary: {
        scratchTotal: `Scratch Pad Total`,
        totalActualEmployee: `Total Employee Time`,
        totalTime: 'Total Time'
      },
      employeesDropdown: {
        column: {
          status: 'Status',
          name: 'Name',
          timeAvailable: 'Time available',
          allocation: 'Allocation',
          role: 'Role',
          contract: 'Contract',
          skills: 'Skills',
          tasks: 'Tasks',
          taskNames: 'Capable tasks',
          holidays: 'Total Monthly Holidays',
          attendances: 'Total Monthly Attendances',
          workingHours: 'Total Monthly Working Hours'
        },
        employeeStatus: {
          available: 'Available',
          partly_available: 'Partly available',
          unavailable: 'Unavailable'
        },
        Allocation: {
          allocated: 'Allocated',
          notAllocated: 'Not allocated'
        },
        availabilities: {
          header: 'Available staff from other locations',
          footer: 'After staff coverage has been arranged, press Action to assign staff into your roster',
          action: 'Action',
          notFound: 'No availabilities from other locations found!'
        },
        select: 'Select',
        myLocation: 'My location',
        fromOtherLocations: 'Available Staff From Other Locations',
        timeRequired: 'Time required',
        shiftLength: 'Shift length',
        waitingAllocation: 'Waiting on allocation',
        noStaffAvailable: 'No staff are available to work this shift.',
        noStaffAvailableFromOtherLocations: 'No staff from other locations are available to work this shift.',
        assignByName: 'Assign by name',
        assignByRole: 'Assign by role',
        contractRoleSection: {
          noData: 'No roles are eligible for this shift at this location',
          role: 'Role',
          maxShiftLength: 'Max Shift Length',
          totalStaffWithRole: 'Total staff with role',
          availableStaffWithRole: 'Available staff with role'
        }
      },
      staffAllocation: {
        sendStaffToAnotherLocation: 'Send staff to another location',
        selectShiftsAndLocations: 'Select shifts and locations',
        noNeedOfAllocation: 'No locations have registered they are looking for staff',
        staffRequest: 'Staff request'
      },
      changeTimes: {
        startTime: 'Start Time',
        endTime: 'End Time',
        startError: (time: string) => `Cannot change start time: there is a shift starting at ${time}`,
        endError: (time: string) => `Cannot change end time: there is a shift ending at ${time}`,
        openBeforeStartError: 'Opening time cannot be before start time',
        closeAfterEndError: 'Closing time cannot be after end time',
        closeBeforeOpenError: 'Closing time must be after open time',
        lengthError: (hours: number) => `The day must cover at least ${hours} hours.`
      },
      changeOpenClosingTimes: {
        openTime: 'Opening Time',
        closeTime: 'Closing Time'
      },
      taskCapability: {
        available: `Staff are available with the required skills`,
        partlyAvailable: `Staff are only partly available with the required skills`,
        unavailable: `No staff are available with the required skills`
      }
    },
    budget: {
      rows: {
        financial: 'Sales target (¥)',
        hqAllocated: 'HQ Allocated Budget',
        locationForecast: 'Location Forecast',
        rosteredBudget: 'Rostered Budget',
        deltaTime: 'Delta Time',
        needStaff: 'Need Staff',
        totalEmployees: 'Employees Rostered/Required'
      },
      vacantShifts: {
        title: (count: number) => `Vacant Shift${count === 1 ? '' : 's'} (${count.toString()})`
      },
      noTargets: 'Target data has not been imported for this date.',
      unsavedChanges: 'There are unsaved changes to the budget. Are you sure you want to leave?',
      filePrefix: 'budget',
      uploadBudget: 'Upload Budget',
      csvHeader: {
        shopId: 'Shop Id',
        shopName: 'Shop Name',
        date: 'Date',
        locationForecast: 'Location Forecast',
        dailySalesTarget: 'Daily Sales Target',
        rosterHours: 'Roster Hours'
      }
    },
    summary: {
      monthlyTotal: 'Monthly Total',
      max: 'Max.',
      min: 'Min.',
      periodTotal: 'Period Total',
      monthly: 'Monthly',
      weekly: 'Weekly',
      holiday: 'H',
      available: 'A',
      reassigned: 'OS',
      noData: 'Employee data has not been setup for the given period.',
      generate: 'Generate Rosters',
      allocateStaff: 'Allocate Staff',
      allocateStaffMessage:
        'Please make sure all shop managers have already generated the rost, this process will take awhile.',
      allocateStaffEst: 'It takes about 10 minutes for the process.',
      askForConfirmation: 'Do you wish to proceed?',
      total: 'Total',
      employee: 'Employee',
      publish: 'Publish Rosters',
      published: 'Published',
      lastPublished: 'Last Published',
      shiftSummaryFileName: 'rosters',
      taskSummaryFileName: 'tasks',
      notificationTitle: 'Announcement of shift release',
      notificationMessage: 'Shifts has been published. Please check the published shifts.',
      states: {
        paid: 'Paid day off',
        dayOff: 'Day off',
        rosterDayOff: 'RDO',
        working: 'Working'
      },
      print: {
        weekly: {
          fileName: (date: string) => `weekly-summary-${date}.pdf`,
          fileTitle: (date: string) => `Weekly Summary: ${date}`
        },
        monthly: {
          fileName: (date: string) => `monthly-summary-${date}.pdf`,
          fileTitle: (date: string) => `Monthly Summary: ${date}`
        }
      },
      publishNotification: {
        prefix: 'Rosters for',
        success: 'have been published.',
        failure: 'could not be published.'
      },
      resetRosters: {
        buttonLabel: 'Reset Rosters',
        modal: {
          title: 'Reset rosters',
          message: 'Do you want to reset all the rosters in the current roster period?'
        },
        error: 'Failed to reset rosters'
      },
      generateConfirmation: (period: string) =>
        `This action will delete all existing rosters for ${period}. Do you want to continue?`,
      compliance: {
        totalHolidays: 'Total Monthly Holidays',
        totalAttendance: 'Attendance Totals',
        attendanceHome: 'Home Loctn',
        attendanceRemote: 'Rmote Loctn',
        attendanceOverall: 'Overall Total',
        attendanceRemoteTooltip: (
          date: string,
          locationId: number,
          locationName: string,
          hasHomeAttendance?: boolean
        ) => `${date} ${locationId} ${locationName} ${hasHomeAttendance ? 'plus Home Location' : ''}`,
        totalShifts: 'Total Monthly Shifts',
        totalUnassigned: 'Total Monthly Unassigned Avaliable Days',
        showCompliance: 'Show Compliance',
        showMonthly: 'Show Monthly',
        totalWorkDays: 'Total Work Days',
        totalRosterShifts: 'Total Shifts',
        totalRosterUnassigned: 'Total Unassigned Shifts',
        advancedLeaveHeader: 'Leave / Unavailability Totals',
        advancedLeaveTotal: 'Overall Total',
        rostered: 'Rostered',
        notRostered: 'Not Rostered'
      },
      monthlySort: {
        sort: 'Sort',
        item: 'Item',
        ascDes: 'Ascending/Descending',
        max: 'Max Working Hour (Monthly)',
        min: 'Min Working Hour (Monthly)',
        periodTotal: 'Period Total (Monthly)',
        shopPosition: 'Shop position',
        name: 'Name',
        employeeId: 'Employee Id',
        contractType: 'Contract Type',
        role: 'Role'
      },
      monthlyTotalTooltip: {
        totals: 'Totals:',
        employeeRosteredRequiredHeader: 'Employees rostered/required',
        employeeRosteredRequired:
          'are totals for this location, including staff from other locations that are temporarily working at this location.',
        monthlyTotalsHeader: 'Monthly Totals',
        monthlyTotals:
          'are totals for all staff who are permanently assigned to this (their home) location, including if they are temporarily assigned to work at another location.'
      }
    },
    settings: {
      unsaved: 'There are unsaved changes. Are you sure you want to leave?',
      pages: {
        system: 'System',
        manageStaff: 'Manage Staff',
        manageSkills: 'Manage Staff Skills',
        availability: {
          name: 'Manage Availability',
          print: {
            fileName: (date: string) => `manage-availability-${date}.pdf`,
            fileTitle: (date: string) => `Manage Availability: ${date}`
          }
        },
        locations: {
          label: 'Manage Locations',
          essMessages: 'ESS Announcements',
          myLocation: 'My Location'
        },
        skills: 'Manage Skills',
        tasks: 'Manage Tasks',
        breaks: 'Manage Breaks',
        personas: 'Manage Personas',
        contractAndRoles: 'Manage Contracts & Roles',
        advancedLeave: 'Manage Advanced Leave',
        standardLeave: 'Manage Standard Leave',
        userAccounts: 'Manage User Accounts',
        organisationChart: 'Organisation Chart'
      },
      manageAvailability: {
        availability: 'Availability',
        hours: 'Available Hours',
        rosteredHours: 'Rostered Hours',
        rosteredLocation: 'Rostered Location',
        rosteredLocationNotRostered: 'Not Rostered',
        rosteredLocationHome: (locationId: string, locationName: string) =>
          `Home location ${locationId} ${locationName}`,
        rosteredLocationRemote: (locationId: string, locationName: string) =>
          `Remote location ${locationId} ${locationName}`,
        pattern: 'Work Pattern Hours',
        endBeforeStart: 'The end time must be before the start time.',
        leaveForPeriod: 'Leave for this roster period',
        inactiveLeaveToolTip: (leaveName: string) => `${leaveName} is now a disabled leave type`,
        warnings: {
          criticalWarning: 'Critical Warning',
          optionalWarning: 'Optional Warning',
          noAvailability: 'The user has been allocated a shift outside of their availability.',
          partialAvailability: 'The user is only partially available for this shift.'
        }
      },
      manageStaff: {
        employeeId: 'Employee ID',
        employeeName: 'Employee Name',
        katakanaName: 'Katakana Name',
        authority: 'Authority/Persona',
        selectPersonas: 'Select authority',
        selectLocations: 'Select locations',
        workPattern: {
          headerLabel: 'Work Pattern'
        },
        skills: {
          headerLabel: 'Skills'
        },
        mixMax: {
          monthlyHeaderLabel: 'Monthly',
          weeklyHeaderLabel: 'Weekly',
          minHours: 'Min Hours',
          maxHours: 'Max Hours',
          weeklyExceedsMonthly: 'Maximum weekly hours exceeds maximum monthly hours'
        },
        personnelDetails: {
          headerLabel: 'Personnel Details',
          dateOfBirth: 'Date of birth',
          hiredDate: 'Hired Date',
          endProbation: 'End of Probation Date',
          leftCompanyDate: 'Left Company Date',
          leftCompanyWarning: (name: string, date: string) => `${name} has shifts on the following days after ${date}:`
        },
        location: {
          headerLabel: 'Location Details',
          assignLocation: 'Assigned Location',
          employeeContract: 'Employee Contract',
          role: 'Role',
          roleUnassigned: 'Unassigned',
          aditionalLocations: 'Additional locations'
        },
        role: {
          admin: 'Admin',
          seniorManager: 'Senior Manager',
          manager: 'Manager',
          staff: 'Staff'
        },
        resetPassword: 'Reset Password',
        report: {
          report: 'report',
          gdprReport: 'GDPR Report',
          generateReportTitle: (employeeName: string) => `Generate report for ${employeeName}?`,
          generateReport: 'Generate',
          recordedInformation: (tenant: string) => `Recorded information in SNPS Shift for ${tenant}`,
          datePrinted: (date: string) => `Date of report: ${date}`,
          personnel: {
            title: 'Personnel Data:',
            name: 'Name:',
            employeeId: 'Employee Id:',
            dob: 'Date of Birth:',
            homeLocation: 'Home Work Location:',
            dateHired: 'Date Hired:',
            endOfProbation: 'End of Probation:',
            dateLeft: 'Date Left Company:'
          },
          workAvailabilty: {
            title: 'Weekly Work/Availability Pattern:'
          },
          personas: {
            title: 'Personas Assigned:'
          },
          remoteWork: {
            title: 'Remote Work Locations:'
          },
          recordedSkills: {
            title: 'Recorded Skills:'
          },
          contract: {
            title: 'Contract and Role Details:',
            role: 'Role:',
            contract: 'Contract:',
            contractTerms: 'Contract Terms:',
            maxSingleShiftDuration: 'Maximum Single Shift Duration:',
            maxMultiShiftDuration: 'Maximum Multiple Shift Duration:',
            notePt1: 'Note:',
            notePt2: '00:00',
            notePt3: 'means this contract excludes multiple shifts in any given roster'
          },
          leaveHistory: 'Leave/Time Off History:',
          rosterHistory: 'Roster History:',
          submittedAvailabilityHistory: 'Submitted Availability History:'
        },
        resetButton: 'Reset',
        deleteUser: 'Delete',
        deleteButton: 'Delete',
        deleteCancel: 'Cancel',
        casual: 'Casual',
        addCasual: {
          firstName: 'First Name',
          lastName: 'Last Name',
          delete: 'Delete',
          add: 'Add Casual Staff'
        },
        noNotes: 'No notes for this employee.',
        contractUnassigned: 'Unassigned'
      },
      manageAnnouncements: {
        announcement: 'Announcement',
        activeInactive: 'Active / Inactive',
        title: 'Title',
        text: 'Text',
        displayDate: 'Display date',
        showAtDate: 'Show at date',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        emptyAnnouncementsList: 'The list of announcements is empty!',
        unsavedChanges: 'There are unsaved changes to the announcements. Are you sure you want to leave?'
      },
      location: {
        locationNumber: 'Location Number',
        locationName: 'Location Name',
        supervisor: 'Supervisor',
        companyCode: 'Company Code',
        companyName: 'Company Name',
        divisionName: 'Division Name',
        brandName: 'Brand Name',
        SVName: 'SV Name',
        prefecture: 'Prefecture',
        shopName: 'Shop Name',
        shopCode: 'Shop Code',
        openingDate: 'Opening Date',
        closedDate: 'Closed Date',
        inventoryDate: 'Inventory Date',
        shiftRequestDeadline: 'Shift Request Deadline',
        deadlineESSReminder: 'Deadline ESS Reminder',
        maxLeaveEachDay: 'Max. Leave Each Day (Person)',
        shopType: 'Shop Type',
        notDefined: 'Not defined'
      },
      manageSkills: {
        skill: 'Skill',
        activeInactive: 'Active / Inactive',
        displayName: 'Display name',
        skillName: 'Skill name',
        tooltip: 'Tooltip',
        emptySkillsList: 'The list of skills is empty!',
        print: {
          staffSkillsOverview: 'Staff Skills Overview',
          skillCapability: 'Skills Capability',
          printBySkill: 'Print skills capabilities',
          printByStaffName: 'Print staff skill overview'
        },
        errors: {
          inUse: 'Skills are in use and cannot be made inactive',
          optional: (skill: string, task: string) => `Skill ${skill} is an optional skill for task: ${task}`,
          mandatory: (skill: string, task: string) => `Skill ${skill} is a mandatory skill for task: ${task}`
        },
        export: {
          success: 'Staff Skill CSV successfully exported'
        },
        import: {
          success: (count: number) => `${count} staff have had their skills updated.`
        }
      },
      manageTasks: {
        task: 'Task',
        activeInactive: 'Active / Inactive',
        taskName: 'Task name',
        displayName: 'Display name',
        icon: 'Icon',
        textColor: 'Text color',
        colors: 'Colors',
        defaultDuration: 'Default duration (minutes)',
        wholeShift: 'Fit to shift',
        supplementaryTask: 'Supplementary task',
        includeInSummaryTotals: 'Include in monthly summary totals',
        calculateWorkingHours: 'Calculate working hours',
        skill: 'Mandatory Skills',
        optionalSkill: 'Optional Skill',
        selectSkills: 'Select skills',
        emptyTasksList: 'The list of tasks is empty!',
        activeTasks: 'Active Tasks',
        inactiveTasks: 'Inactive Tasks',
        yes: 'Y',
        no: 'N',
        printFileName: (organisationName: string, date: string) => `${organisationName}-tasks-${date}.pdf`,
        errors: {
          inUse: 'Tasks are in use and cannot be made inactive',
          shopTemplate: (task: string) => `Task ${task} is currently allocated to the following shop templates:`,
          libraryTemplate: (task: string) => `Task ${task} is currently allocated to the following library templates:`
        },
        iconSections: {
          standard: 'Standard',
          retail: 'Retail',
          hospitality: 'Hospitality',
          numbers: 'Numbers'
        }
      },
      manageBreaks: {
        generalSettings: 'General Break Settings',
        includeBreaks: {
          title: 'Include breaks in roster totals',
          description: 'Whether time spent on break should be included in the roster totals',
          on: 'Include breaks in totals',
          off: 'Exclude breaks from totals'
        },
        breakOffset: {
          title: 'Break offset',
          description: 'Earliset/latest breaks can be set for the beginning/end of the day',
          firstBreak: 'Set how many minutes after the start of the shift the first break can occur',
          lastBreak: 'set how many minutes before the end of the shift the last break can occur'
        },
        severeBreakWarnings: {
          title: 'Severe Break Warnings',
          description: 'If toggled to on, rosters must obey break rules before they can be saved',
          on: 'Break errors treated as severe',
          off: 'Break errors treated as warnings'
        },
        canSplitBreaks: {
          title: 'Can Split Breaks',
          description: 'Whether minimum break time can be spread across multiple breaks',
          on: 'May split time across multiple breaks',
          off: 'Must be taken as a single break'
        },
        breakTimeLimits: {
          title: 'Break Time Limits',
          settingTitle: 'Minimum Break Lengths',
          settingDescription: 'Amount of break time which must be provided depending on shift length',
          level0: 'All shifts',
          tierDescription: 'Shifts longer than:',
          shiftLength: 'Shift length',
          minimumBreakTime: 'Minimum break time',
          addTier: 'Add Tier',
          removeTier: 'Remove Tier'
        }
      },
      managePersonas: {
        persona: 'Persona',
        personaName: 'Persona name',
        admin: {
          name: 'Admin Only',
          tooltip: `Only admins can set/remove this persona.`
        },
        management: {
          name: 'Management',
          tooltip: `Whether a user can act as a manager. Relates to the setting "Management Attendance Required".`
        },
        templateLibrarian: {
          name: 'Template Librarian',
          tooltip: `Whether a user can make updates to the template library.`
        },
        emptyList: 'The list of personas is empty!'
      },
      manageContractsAndRoles: {
        contract: 'Contract',
        newContractDisplayName: 'New contract display name',
        filter: {
          displayActive: 'Display active contracts',
          displayAll: 'Display all',
          displayInactive: 'Display inactive contracts'
        },
        form: {
          displayName: 'Display Name',
          contractName: 'Contract Name',
          contractNameTooltip: 'This name is used for integration to external systems',
          contractCode: 'Contract Code',
          contractCodeTooltip: 'This code/ID is used for integration to external systems',
          deleteContract: 'Delete Contract',
          roleTitle: (contractName: string) => `${contractName} Roles`,
          addRole: 'Role',
          roleName: 'Role Name',
          tooltipNotes: 'Tool Tip Notes',
          deleteRole: 'Delete Role',
          maxShiftDuration: 'Maximum duration of a single shift',
          maxMultiShiftDuration: 'Maximum total duration of multiple shifts',
          maxMultiShiftDurationInfo: 'Maximum total in a roster period.',
          active: 'Active Contract',
          inactive: 'Inactive Contract',
          activeTooltip: 'Inactive Contracts, and the associated Roles, are not shown in the Location Management UI',
          contractType: {
            label: 'Contract Type',
            fullTime: 'Full Time',
            partTime: 'Part Time',
            casual: 'Casual',
            tooltip: 'Required if tenant reverts back to standard contract handling'
          },
          deleteRoleAndReset: 'Delete and reset'
        },
        errors: {
          general: 'Something has gone wrong'
        },
        inactive: {
          confirmation: (contractName: string) => `Are you sure you want to set ${contractName} as inactive?`,
          info: 'Roles associated to this contract are allocated to some employees. Setting to inactive will provent from from being automatically rostered.  Do you want to continue? '
        },
        delete: {
          confirmation: (contractName: string) => `Are you sure you want to delete: ${contractName}?`,
          inUseTitle: 'This contract is being used by the following employees:',
          inUseWithLocation: (locationId: string, locationName: string, employee: string) =>
            `${locationId} - ${locationName}, ${employee} is assigned to this contract.`,
          inUse: (employee: string) => `${employee} is assigned to this contract.`,
          roleInUseTitlePt1: 'This role is still in use.',
          roleInUseTitlePt2: 'If you want to delete the role, it will be reset.',
          roleInUseWithLocation: (locationId: string, locationName: string, employee: string) =>
            `${locationId} - ${locationName}, ${employee}`,
          roleResetInfo: 'The following employees will be set to unassigned',
          roleInUse: (employee: string) => `${employee}`,
          templateResetInfo: "The following templates have a shift that will be reset to 'Select'.",
          roleTemplateInUse: (locationName: string) => `${locationName}`,
          roleTemplateInUseWithLocation: (locationName: string, templateName: string) =>
            `${locationName} - ${templateName}`
        },
        casual: 'CASUAL',
        staffCountUsingContract: (count: number) => `${count} staff in total are using this contract`,
        locationCountUsingContract: (count: number) => `${count} locations have staff using this contract`
      },
      manageLeave: {
        active: 'Active / Inactive',
        leaveUnavailabilityType: 'Leave / Unavailability Type',
        displayName: 'Display Name',
        systemCode: 'External System Code 1',
        systemCode2: 'External System Code 2',
        colors: 'Colors',
        measurementUnits: 'Measurement Units',
        units: {
          days: 'Days',
          hours: 'Hours'
        },
        maximumTotal: 'Maximum Total',
        minimumTotal: 'Minimum Total',
        level: 'Warning/Mandatory',
        maximumConsecutive: 'Maximum Consecutive',
        canOverride: 'Management can override',
        emptyList: 'The list of leave types is empty!',
        leaveType: 'Leave Type',
        per: 'per',
        period: {
          rosterPeriod: 'Roster Period',
          year: 'Year',
          month: 'Month',
          day: 'Day',
          week: 'Week'
        },
        warning: 'Warning',
        mandatory: 'Mandatory',
        override: 'Management can override',
        leaveUnavailabilityTypeToolTip: 'This name is used in export data if required',
        displayNameToolTip:
          'This is the name displayed in the UI, including ESS. It will be truncated to the first few characters if there is not enough room to display in the UI',
        systemCodeTooltip: 'Codes for integration to external HR systems, not used in SNPS Shift',
        maximumTotalTooltip:
          'Disabled = warning when max is exceeded, can submit the total. Enabled = ESS user cannot exceed the max total, cannot submit the total',
        maximumConsecutiveToolTip: 'Currently hard coded value, not currently enforced',
        availableInEss: 'Available in ESS?',
        alwaysShown: 'N/A Always Shown'
      },
      system: {
        desktopAppBehaviour: {
          label: 'Desktop App Behaviour',
          title: 'Highlight system tabs',
          description: 'Set the appearance and colour'
        },
        customerSpecific: {
          label: 'Customer Specific',
          allocateStaff: 'Enable Allocate Staff Button',
          allocateStaffDescription: 'This setting is for SUNDI'
        },
        orgName: {
          title: 'Display Company/Organisation',
          description: 'Define what is displayed in the top right',
          options: {
            company: 'Company',
            division: 'Division',
            brand: 'Brand',
            custom: 'Custom name'
          },
          default: 'Organisation Name'
        },
        roster: {
          title: 'Roster Data',
          settings: {
            rosterMonthStart: {
              title: 'Roster month start day',
              description: 'Define the starting day of the month'
            },
            rosterWeekStart: {
              title: 'Week view start day',
              description: 'Define the starting day of the week'
            },
            defaultStartEnd: {
              title: 'Default template period',
              description: 'Default start and end time used when a template is created',
              startTime: 'Start time until',
              endTime: 'End time'
            },
            futureAvailabilityMonths: {
              title: 'Maximum future availability',
              description: 'How many months in advance the system shows the calendar',
              monthCount: (count: number) => `${count} month${count === 1 ? '' : 's'}`
            },
            holidayRegion: {
              title: 'Public holiday region',
              description: 'Which region to show public holidays for',
              options: {
                none: 'None',
                japan: 'Japan'
              }
            },
            minShiftDuration: {
              title: 'Minimum shift duration',
              description: 'Minimum time for a shift. A shift cannot be made shorter than this value',
              minShiftCannotExceedDefaultDuration: 'Minimum shift time cannot be larger than the default duration'
            },
            maxShiftDuration: {
              title: 'Maximum shift duration',
              description: 'Maximum time for a shift. A shift cannot be made longer than this value',
              maxShiftCannotBeShorterThanDefaultDuration:
                'Maximum shift time cannot be shorter than the default duration'
            },
            defaultShiftDuration: {
              title: 'Default shift duration',
              description: 'Default time for a new shift in templates and daily roster'
            },
            maxTimePeriods: {
              title: 'Maximum number of available time periods in each roster period',
              description:
                'The number of time periods an employee can be specified as available (ESS and Manage Staff Availability)',
              count: (number: number) => `${number} shift${number > 1 ? 's' : ''}`
            },
            availabilityDeadline: {
              title: 'Availability Deadline',
              description: 'Which day of the month staff members must input their availability by',
              toggle: 'Automatically Send Reminders',
              notificationDate: 'Notification Date',
              notificationTime: 'Notification Time'
            },
            validation: {
              title: 'Roster Editing Validation',
              managementAttendance: {
                title: 'Management Attendance Required',
                description:
                  'A Manager or Deputy Manager must be in attendance each day (for the duration of a minimum shift)'
              },
              mandatorySkills: {
                title: 'Enforce Mandatory Skills',
                description: 'Mandatory skills requirements are ignored'
              }
            }
          }
        },
        personnelDetails: {
          title: 'Edit Personnel details',
          description: 'Enable personnel date to be editable rather than read only',
          editable: {
            dateOfBirth: 'Date of birth',
            hiredDate: 'Hired Date',
            leftDate: 'Left Company Date',
            endProbDate: 'End of probation date'
          },
          level: {
            view: 'View',
            hide: 'Hide',
            edit: 'Edit'
          }
        },
        lastOfMonth: 'Last',
        optional: 'Optional'
      },
      admin: {
        title: 'Super Admin Settings - For SNPS use only',
        useWithCaution: 'Use with caution',
        settings: {
          minimumIncrement: {
            title: 'Minimum shift increment',
            description: 'Smallest number of minutes a shift start or end time can be changed',
            minutes: (number: number) => `${number} minutes`
          },
          canDeleteRosters: {
            title: 'Can Delete Rosters',
            description: 'Whether daily rosters can be deleted'
          },
          displayEmployeeIds: {
            title: 'Display Employee Ids',
            description: 'Display employee IDs alongside names'
          },
          minStaffHours: {
            title: 'Minimum staff hours',
            description: 'Default least number of hours a staff member has to work each month'
          },
          maxStaffHours: {
            title: 'Maximum staff hours',
            description: 'Default highest number of hours a staff member can work each month'
          },
          maxCustomTemplates: {
            title: 'Custom template maximum',
            description: 'The number of custom templates a customer can create'
          },
          historicalData: {
            title: 'Historical Data Displayed For',
            description: 'How far back in time it is possible to display. (plus the current month)',
            months: (number: number) => `${number} months`,
            noLimit: 'No limit'
          },
          splitShifts: {
            sectionName: 'Split Shifts',
            maxNumber: {
              title: 'Maximum number of shifts',
              description:
                '1 through 3 shifts per employee in any given roster period. 1 shift implies split shifts are disabled.',
              count: (number: number) => `${number} shift${number > 1 ? 's' : ''}`
            },
            minTimeBetween: {
              title: 'Minimum time allowed between shifts',
              description: 'Less than this amount implies a shift with a break'
            }
          },
          reassignment: {
            sectionName: 'Reassignment to other locations',
            model: {
              title: 'Reassignment model',
              onRequestModel: 'On-request model',
              pullModel: 'Pull model',
              disabled: 'Disable reassignment'
            },
            locations: {
              title: 'Staff work at all locations or allocated locations',
              description:
                'Allocated = Locations allocated in Manage Staff or ESS (can be anywhere in the organisation) / All locations = All locations under the SV (assumption all staff are willing to work at locations managed by the SV)',
              allLocations: 'All Locations',
              allocatedLocations: 'Allocated'
            }
          }
        },
        dataCleanUp: {
          title: 'Data clean up',
          deleteAllRosters: {
            title: 'Delete ALL rosters',
            confirmationHeader: 'Delete all ROSTERS',
            confirmationMessage:
              'You are going to delete all rosters data. The operation could not be undone! Do you still want to proceed?'
          },
          deleteAllTemplates: {
            title: 'Delete ALL templates',
            subtitle: 'Note: delete rosters before deleting templates!',
            confirmationHeader: 'Delete all TEMPLATES',
            confirmationMessage:
              'You are going to delete all templates data. The operation could not be undone! Do you still want to proceed?'
          },
          deleteAllAvailability: {
            title: 'Delete ALL availability',
            confirmationHeader: 'Delete all AVAILABILITY',
            confirmationMessage:
              'You are going to delete all availability data. The operation could not be undone! Do you still want to proceed?'
          }
        },
        dataExport: {
          title: 'Data Export',
          tenantData: {
            title: 'Export Tenant Data',
            subtitle: 'Export to SNPS Shift generic format'
          }
        },
        userMaintenance: {
          title: 'User maintenance',
          resetAllPasswords: {
            title: 'Reset ALL passwords to default',
            confirmationHeader: 'Reset all users PASSWORDS',
            confirmationMessage:
              'You are going to reset all user accounts passwords to their default state. The operation could not be undone! Do you still want to proceed?'
          }
        },
        leaveManagement: {
          title: 'Leave/Availability',
          advanced: {
            title: 'Standard or Advanced',
            description: 'Standard has unavailable only',
            labelOn: 'Advanced',
            labelOff: 'Standard'
          }
        },
        contractsAndRolesManagement: {
          title: 'Contracts & Roles',
          advanced: {
            title: 'Standard or Advanced',
            descriptionPt1: 'Standard means tenant-wide settings applied to all employees.',
            descriptionPt2:
              'Advanced enables contracts to be defined for individual roles, which are then assigned to employees.',
            labelOn: 'Advanced',
            labelOff: 'Standard'
          }
        },
        optimiser: {
          title: 'Optimiser Parameters',
          runtimeDuration: {
            title: 'Optimiser runtime duration',
            description:
              "Number of seconds the optimiser will run (assembling/disassembling the payload isn't included in the timeframe!)"
          },
          management: {
            title: 'Management persona in attendance',
            description: 'Hard constraint to force attendance for at least one shift per roster'
          }
        },
        organisationChart: {
          orphanedLocationsHolderName: 'Orphaned Locations',
          filters: {
            displayCurrent: 'Display Current Employees',
            displayAll: 'Display All Employees',
            displayPast: 'Display Past Employees'
          }
        }
      },
      filter: {
        displayActive: 'Display active',
        displayAll: 'Display all',
        displayInactive: 'Display inactive'
      },
      staffFilter: {
        displayCurrent: 'Display Current Employees',
        displayAll: 'Display All Employees',
        displayPast: 'Display Past Employees',
        errors: {
          dataError: 'Data Error: please correct the following',
          invalidMonthlyTimes: (employeeId: string, employeeName: string) =>
            `${employeeId} ${employeeName}, Invalid times in Monthly Min/Max Hours`,
          invalidWeeklyTimes: (employeeId: string, employeeName: string) =>
            `${employeeId} ${employeeName}, Invalid times in Weekly Min/Max Hours`,
          invalidWorkPatternTimes: (employeeId: string, employeeName: string, day: string) =>
            `${employeeId} ${employeeName}, Invalid times in Work Pattern ${day}`,
          invalidLeavingDate: (employeeId: string, employeeName: string) =>
            `${employeeId} ${employeeName}, Invalid left company date`
        }
      },
      preferences: {
        dailyRoster: {
          sectionTitle: 'Daily Roster',
          staffPicker: 'Staff Picker Columns',
          taskDisplay: 'Task Display',
          status: 'Status',
          timeAvailable: 'Time Available',
          allocation: 'Allocation',
          role: 'Role',
          contract: 'Contract',
          totalHolidays: 'Total Monthly Holidays',
          attendances: 'Total Monthly Attendances',
          workingHours: 'Total Monthly Working Hours',
          tasks: 'Tasks',
          capableTasks: 'Capable Tasks',
          personalization: 'Personalization',
          ganttGridLines: 'Gantt Grid Lines',
          ganttGridBarThickness: 'Gantt Grab Bar Thickness',
          openClosingTimes: {
            label: 'Open/Closing Times',
            hidden: 'Hidden',
            fieldsOnly: 'Fields only',
            all: 'Fields and Gantt Bar'
          },
          gridLines: (value: number) => `${value} mins`
        }
      }
    },
    optimiser: {
      notification: {
        generated: 'has been generated.',
        progress: 'is in progress.',
        queued: 'has been queued.',
        deleted: 'has been deleted.',
        failed: (error: string) => `has failed with error code ${error}.`,
        rosterFor: 'Roster for'
      },
      inProgress: 'Optimisation in progress...'
    },
    layout: {
      headerLinks: {
        monthlyBudgets: 'Monthly Budgets',
        monthlyShifts: 'Monthly Shifts',
        weeklyShifts: 'Weekly Shifts',
        dailyShifts: 'Daily Shifts',
        templates: 'Templates',
        systemSetup: 'System Setup',
        notifications: 'Notifications',
        location: 'Location'
      },
      headerMenu: {
        myProfile: 'My Settings',
        language: 'Language',
        languages: {
          english: 'English',
          japanese: 'Japanese'
        },
        about: 'About',
        aboutModal: {
          title: 'About SNPS Shift',
          licensing: 'Licensing:'
        },
        logout: 'Logout'
      },
      underConstruction: 'This page is still in development.'
    },
    common: {
      daysToTake: (n: number) => `This request requires ${n} ${n === 1 ? 'day' : 'days'} of your leave.`,
      daysRemaining: (n: number) => `${n} ${n === 1 ? 'day' : 'days'} remaining`,
      startDate: 'Start Date',
      endDate: 'End Date',
      thisYear: 'This Year',
      request: 'Request',
      back: 'Back',
      update: 'Update',
      deny: 'Deny',
      approve: 'Approve',
      next: 'Next',
      previous: 'Previous',
      sort: 'Sort',
      print: 'Print',
      printModal: {
        title: 'Print Options',
        screenView: 'Screen View',
        posterView: 'Poster View',
        printKey: 'Print the task legend',
        print: 'Print',
        notPrint: 'Not Print'
      },
      required: 'Required',
      upload: 'Upload',
      download: 'Download',
      na: 'N/A',
      time: 'Time',
      date: 'Date',
      submit: 'Submit',
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
      publish: 'Publish',
      edit: 'Edit',
      delete: 'Delete',
      deleteAll: 'Delete all',
      reset: 'Reset',
      resetAll: 'Reset all',
      toBeDeleted: 'To be deleted!',
      close: 'Close',
      view: 'View',
      loading: 'LOADING...',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      phoneNumber: 'Phone number',
      pagination: {
        pageXOfY: (page: number, total: number) => `Page ${page} of ${total}`
      },
      search: 'Search',
      mandatory: (field: string) => `${field} is required`,
      ok: 'OK',
      continue: 'Continue',
      confirm: 'Please Confirm',
      yes: 'Yes',
      no: 'No',
      locationName: 'Location Name',
      total: 'Total',
      employee: 'Employee',
      daysOfWeek: ['S', 'M', 'Tu', 'W', 'Th', 'F', 'S'],
      daysOfWeekMid: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daysOfWeekFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Holiday'],
      daysOfWeekFullStartMonday: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Holiday'
      ],
      success: 'Success!',
      error: 'An error occurred',
      select: 'Select',
      jp: 'JP',
      en: 'EN',
      today: 'Today',
      notPermitted: 'This account does not have permission to access this site.',
      file: {
        download: 'Download',
        upload: 'Upload',
        selectFile: 'Select file',
        pleaseSelect: 'Please select a file to upload.',
        downloadShifts: 'Download shifts',
        downloadSummaries: {
          title: 'Download Summaries',
          options: {
            shifts: 'Shifts',
            tasks: 'Tasks'
          }
        }
      },
      totals: {
        max: 'Max.',
        min: 'Min.',
        periodTotal: 'Period Total',
        dailyTotal: 'Daily Total',
        actualTotal: 'Actual Total',
        break: 'Break',
        monthlyTotal: 'Monthly Total',
        weeklyTotal: 'Weekly Total',
        attendanceTotal: 'Attendance Total'
      },
      enterValidPhone: 'Please enter a valid phone number.',
      enterValidEmail: 'Please enter a valid email.',
      severity: {
        critical: 'Critical warning',
        warning: 'Warning'
      },
      notesModalTitle: 'Notes',
      notesPrintLabel: 'Notes:',
      export: 'Export',
      import: 'Import',
      set: 'Set',
      add: 'Add',
      none: 'NONE',
      home: 'Home',
      shift: 'Shift',
      requested: 'Requested',
      available: 'Available',
      requestStatus: 'Request Status',
      requestSubmitted: (date: string) => `Submitted: ${date}`,
      approved: 'Approved',
      denied: 'Denied',
      pending: 'Pending',
      cancelledByEmployee: 'Withdrawn by employee',
      cancelledByManager: 'Cancelled by manager'
    },
    notifications: {
      filter: {
        all: 'All',
        roster_generation: 'Roster generation',
        roster_publish: 'Roster publish',
        application: 'Application'
      },
      noNotifications: 'There are currently no messages to display for this session',
      push: {
        rosterPublishedTitle: 'Roster Published',
        rosterPublishedMessage: (startDate: string, endDate: string) =>
          `Roster in period ${startDate} - ${endDate} has been published.`,
        availabilityDeadlineTitle: 'Availability Deadline',
        availabilityDeadlineMessage:
          'Please ensure your availability for the coming roster period has been entered before close of business tomorrow.'
      },
      leftCompany: (name: string, date: string) =>
        `${name} left the company on ${date}, and is rostered on dates after their leaving date:`,
      willLeaveCompany: (name: string, date: string) =>
        `${name} will leave on ${date}, and is rostered on dates after their leaving date:`
    },
    keys: {
      reassigned: 'Reassigned',
      unassigned: 'Unassigned'
    },
    colors: {
      black: 'Black',
      white: 'White'
    },
    dropdown: {
      noOptions: 'No options to select!'
    }
  }
});
